import React from 'react';
import { Circle, InnerWrapper, Icon, Value, Unit, ToolTip } from './elements';
import { getIndicatorConfig } from 'utils/common';
import { useText, useFormatNumber } from 'common/hooks';

type Props = {
  readonly className?: string;
  readonly indicator: string;
  readonly totalUserSavings: number;
  readonly userGoal: number;
};

export default function GoalProgressCircle({
  className,
  indicator,
  totalUserSavings,
  userGoal,
}: Props): React.ReactElement {
  const t = useText();
  const formatNumber = useFormatNumber();
  const { color, icon, unitPath } = getIndicatorConfig(indicator);

  const percentageComplete = userGoal ? (totalUserSavings * 100) / userGoal : 0;

  if (!userGoal) {
    return (
      <InnerWrapper className={className}>
        <ToolTip
          text={t(
            `challenge.ChaPaD24B.PersonalInsights.your_total_savings.${indicator}`
          )}
        >
          <Icon icon={icon} color={color} />
          <Value>{formatNumber(totalUserSavings, 0)}</Value>
          <Unit>{t(unitPath)}</Unit>
        </ToolTip>
      </InnerWrapper>
    );
  }

  return (
    <Circle className={className} percent={percentageComplete} color={color}>
      <ToolTip
        text={t(
          `challenge.ChaPaD24B.PersonalInsights.your_total_savings.${indicator}`
        )}
      >
        <Icon icon={icon} color={color} />
        <Value>{formatNumber(totalUserSavings, 0)}</Value>
        <Unit>{t(unitPath)}</Unit>
      </ToolTip>
    </Circle>
  );
}
